class ProductPage {
    constructor() {
        this.container = document.querySelector('.product-section');
        if (!this.container) return;

        this.initGallery();
        this.initVariants();
        this.initQuantity();
        this.initAccordions();
        this.initModal();
        this.initAddToCart();
    }

    initGallery() {
        this.mainImage = this.container.querySelector('.product-gallery__main-image');
        this.thumbnails = this.container.querySelectorAll('.product-gallery__thumbnail');
        this.thumbnailContainer = this.container.querySelector('.product-gallery__thumbnails');
        this.prevBtn = this.container.querySelector('.product-gallery__arrow--prev');
        this.nextBtn = this.container.querySelector('.product-gallery__arrow--next');
        this.currentIndex = 0;

        if (this.thumbnails.length > 0) {
            this.thumbnails.forEach((thumb, index) => {
                thumb.addEventListener('click', () => this.goToSlide(index));
            });
        }

        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', () => this.goToSlide(this.currentIndex - 1));
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', () => this.goToSlide(this.currentIndex + 1));
        }

        this.updateGalleryNav();
    }

    goToSlide(index) {
        if (index < 0 || index >= (this.thumbnails.length || 1)) return;

        this.currentIndex = index;
        const selectedThumb = this.thumbnails[index];

        if (selectedThumb) {
            const newSrc = selectedThumb.getAttribute('data-image-url');
            if (newSrc) {
                this.mainImage.src = newSrc;
                this.mainImage.srcset = ''; // Clear srcset to force browser to use the new src
            }

            this.thumbnails.forEach(t => t.classList.remove('is-active'));
            selectedThumb.classList.add('is-active');

            // Scroll thumbnails if needed
            if (this.thumbnailContainer) {
                const scrollLeft = selectedThumb.offsetLeft - (this.thumbnailContainer.offsetWidth / 2) + (selectedThumb.offsetWidth / 2);
                this.thumbnailContainer.scrollTo({
                    left: scrollLeft,
                    behavior: 'smooth'
                });
            }
        }

        this.updateGalleryNav();
    }

    updateGalleryNav() {
        if (this.prevBtn) {
            this.prevBtn.classList.toggle('product-gallery__arrow--disabled', this.currentIndex === 0);
        }
        if (this.nextBtn) {
            this.nextBtn.classList.toggle('product-gallery__arrow--disabled', this.currentIndex === (this.thumbnails.length - 1 || 0));
        }
    }

    initVariants() {
        this.form = this.container.querySelector('.product-form');
        this.variantIdInput = this.container.querySelector('input[name="id"]');
        this.priceElement = this.container.querySelector('.product-info__price');
        this.swatches = this.container.querySelectorAll('.product-swatch');
        this.sizeButtons = this.container.querySelectorAll('.product-button');

        const productDataElement = document.getElementById('product-data');
        this.productData = productDataElement ? JSON.parse(productDataElement.textContent) : null;

        if (this.swatches.length > 0) {
            this.swatches.forEach(swatch => {
                swatch.addEventListener('click', () => {
                    this.swatches.forEach(s => s.classList.remove('is-active'));
                    swatch.classList.add('is-active');
                    this.updateVariant();
                });
            });
        }

        if (this.sizeButtons.length > 0) {
            this.sizeButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.sizeButtons.forEach(b => b.classList.remove('is-active'));
                    btn.classList.add('is-active');
                    this.updateVariant();
                });
            });
        }
    }

    updateVariant() {
        if (!this.productData) return;

        const selectedOptions = [];
        const activeSwatch = this.container.querySelector('.product-swatch.is-active');
        const activeSize = this.container.querySelector('.product-button.is-active');

        if (activeSwatch) selectedOptions.push(activeSwatch.getAttribute('data-value'));
        if (activeSize) selectedOptions.push(activeSize.getAttribute('data-value'));

        const variant = this.productData.variants.find(v => {
            return v.options.every(option => selectedOptions.includes(option));
        });

        if (variant) {
            this.variantIdInput.value = variant.id;
            this.priceElement.textContent = this.formatMoney(variant.price);

            // Update gallery if variant has featured image
            if (variant.featured_image) {
                const thumbIndex = Array.from(this.thumbnails).findIndex(t => t.getAttribute('data-image-id') === variant.featured_image.id.toString());
                if (thumbIndex !== -1) {
                    this.goToSlide(thumbIndex);
                } else {
                    this.mainImage.src = variant.featured_image.src;
                    this.mainImage.srcset = ''; // Clear srcset
                }
            }

            // Update submit button state
            const submitBtn = this.container.querySelector('.product-form__submit');
            if (submitBtn) {
                submitBtn.disabled = !variant.available;
                submitBtn.textContent = variant.available ? 'Застосувати' : 'Немає в наявності';
            }
        }
    }

    formatMoney(cents) {
        const amount = (cents / 100).toFixed(0);
        return `${amount} грн`;
    }

    initQuantity() {
        this.quantityInput = this.container.querySelector('.product-quantity__input');
        const minusBtn = this.container.querySelector('.product-quantity__btn--minus');
        const plusBtn = this.container.querySelector('.product-quantity__btn--plus');

        if (minusBtn && plusBtn && this.quantityInput) {
            minusBtn.addEventListener('click', () => {
                const val = parseInt(this.quantityInput.value) || 1;
                if (val > 1) this.quantityInput.value = val - 1;
            });

            plusBtn.addEventListener('click', () => {
                const val = parseInt(this.quantityInput.value) || 1;
                this.quantityInput.value = val + 1;
            });
        }
    }

    initAccordions() {
        const headers = this.container.querySelectorAll('.product-accordion__header');
        headers.forEach(header => {
            header.addEventListener('click', () => {
                const accordion = header.closest('.product-accordion');
                const isOpen = accordion.classList.contains('is-open');

                // Close all others
                this.container.querySelectorAll('.product-accordion').forEach(a => a.classList.remove('is-open'));

                if (!isOpen) {
                    accordion.classList.add('is-open');
                }
            });
        });
    }

    initAddToCart() {
        if (!this.form) return;

        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const submitBtn = this.form.querySelector('[type="submit"]');
            if (!submitBtn) return;

            const originalText = submitBtn.textContent;
            submitBtn.disabled = true;
            submitBtn.textContent = 'Додавання...';

            try {
                const formData = new FormData(this.form);
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    if (window.cartDrawer) {
                        await window.cartDrawer.fetchCart();
                        window.cartDrawer.open();
                    } else {
                        window.location.href = '/cart';
                    }
                } else {
                    const data = await response.json();
                    alert(data.description || 'Error adding to cart');
                }
            } catch (error) {
                console.error('Error:', error);
                // alert('An error occurred. Please try again.');
            } finally {
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new ProductPage();
});
